export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["InvestorPortalView"] = "investor-portal-view";
    OnboardingStep["DataRoomView"] = "data-room-view";
    OnboardingStep["InvestorDetails"] = "investor-details";
    OnboardingStep["InvestorClassification"] = "investor-classification";
    OnboardingStep["TaxDeclarations"] = "tax-declarations";
    OnboardingStep["KYCOrKYB"] = "kyc-or-kyb";
    OnboardingStep["DocumentSigning"] = "document-signing";
    OnboardingStep["CommitmentConfirmation"] = "commitment-confirmation";
})(OnboardingStep || (OnboardingStep = {}));
export var OnboardingStepStatus;
(function (OnboardingStepStatus) {
    OnboardingStepStatus["Requested"] = "requested";
    OnboardingStepStatus["StartedByInvestor"] = "started-by-investor";
    OnboardingStepStatus["InReview"] = "in-review";
    OnboardingStepStatus["Completed"] = "completed";
    OnboardingStepStatus["Disabled"] = "disabled";
    OnboardingStepStatus["MoreInformationRequested"] = "more-information-requested";
})(OnboardingStepStatus || (OnboardingStepStatus = {}));
//# sourceMappingURL=index.js.map